// removed by extract-text-webpack-plugin
module.exports = {"input":"vtUOj_wE3LxoBiEBPNla_","box":"_1PeIH1xDiO1YOinKC_rgz1","info":"_1UHqKoOzfzY1dp5W3kNQ1e","primary":"_12f0aPFmVW1Dll_HmqNkAl","priceContainer":"gFCUTw4fT1thNRdTJhWED","price":"_1-9M8NXMVqNP7LhiuFcDYF","originalPrice":"_5WRVk8jMUlLvgLJabR5oI","actionGroup":"_3lKXCefETGEpElqwFEtTWu","duration":"_1N2XpvK1wkiMPiMdbdqzd9","action":"_2WrhSWSDFFXDmBVEYKy__1","btn":"_3R-UxKH5Mm_oyO2kIU5Guh","borderTopRadius":"gH7NObdgF92AbknGlZmJ9","borderBottomRadius":"_1Zbdb4T3IGs_XGFCFSgHxK","borderBottom":"_2HfxXB631XmjHJ2cW_GGku","marginBottom":"_2yp1vgmrIAtkB61sLHhhT7","modalDesc":"_2FzRWPYYpgxT6rzwTJ6UIL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/StepButton.scss
// module id = 317
// module chunks = 0